import { ActionConfirmation } from '@app/components/base/ActionConfirmation';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { socialExport } from '@mi-front/api-clients';
import { LinkOff } from '@mui/icons-material';
import { Box, Button, CircularProgress } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';

type Props = {
  stationId: string;
  platform: SocialPlatform;
};

export const PlatformDisconnect = ({ stationId, platform }: Props) => {
  const queryClient = useQueryClient();
  const query = socialExport.useListByPlatformConnection(platform.id);
  const mutation = socialExport.useDeleteConnection({
    mutation: {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: query.queryKey,
        });
      },
    },
  });

  return (
    <Box>
      <ActionConfirmation
        trigger={(onClick) => (
          <Button
            color="warning"
            size="small"
            variant="outlined"
            startIcon={
              mutation.isPending ? <CircularProgress size={16} color="inherit" /> : <LinkOff />
            }
            disabled={mutation.isPending}
            onClick={onClick}
          >
            <FormattedMessage id="socialExport.manage.disconnect" defaultMessage="Desconectar" />
          </Button>
        )}
        title={<FormattedMessage id="admin.integrations.warningTitle" defaultMessage="Atención" />}
        description={
          <FormattedMessage
            id="admin.integrations.warningContent"
            defaultMessage="Estás a punto de desconectar esta integración. ¿Estás seguro?"
          />
        }
        onConfirm={() =>
          mutation.mutate({
            station: stationId,
            platform: platform.id,
          })
        }
        confirmText={<FormattedMessage id="admin.integrations.accept" defaultMessage="Aceptar" />}
        cancelText={<FormattedMessage id="admin.integrations.cancel" defaultMessage="Cancelar" />}
      />
    </Box>
  );
};
